module.exports = __webpack_public_path__ + "static/media/eye.320fe8b0.svg";